<template>
  <div>
		<!-- 子路由出口：订单详情（servicedatails） -->
		<router-view v-if="$route.path.includes('servicedatails')"></router-view>
		<!-- 列表页 -->
		<div v-else>
			   <el-carousel trigger="click">
					 <el-carousel-item v-for="item in bannerlist" :key="item">
					   <img :src="item.image" alt="" srcset="" class="bannerlist" @click="downloadFile(item.file)" />
					 </el-carousel-item>
			   </el-carousel>
			   
			   <div class="sobox">
				   <div class="soso">
					   <div class="soinput">
						   <i class="el-icon-search"></i>
						  <input type="text" placeholder="请输入您要搜索的内容" v-model="keyword"> 
					   </div>
					   <button  @click="chaxun">搜索</button>
				   </div>
			   </div>
			   
			   <div class="xqlist">
				   <figure style="width:100%; text-align:center;padding-top:50px;" v-if="list.length==0">
					   <img src="@/assets/kong.png" alt="" srcset="" />
					   <figcaption>暂无数据</figcaption>
				   </figure>
				   <div class="liebiao1" v-for="item in list" :key="item" @click="getdatails(item.d_id)">
						<div class="title">
							<h4 class="titleh4">{{item.name}}</h4>
							<span v-if="item.status==-1">已驳回</span>
							<span v-if="item.status==0">审核中</span>
							<span v-if="item.status==1">报价中</span>
							<span v-if="item.status==2">已结束</span>
						</div>
						<div class="titleTiem">
							<img src="@/assets/tiem.png" alt="" srcset="" />
							<span>发布时间：{{item.create_time}}</span>
						</div>
						<div class="hylist">
							<div style="">
								<div v-for="(i,index) in item.industries" :key="index" >{{i}}</div>
							</div>
						</div>
						<div class="hybox">
							<span>
							    {{item.description}}
							</span>
						</div>
						<div class="hytiem" @click.stop="baojia(item.d_id)" v-if="item.service_quote==0">
							<span>报价剩余时间：<CountDown :endTime="item.display_end_time*1000"></CountDown></span>
							<div style="width: 174px;">立即报价 {{item.quotes_count || '0'}}/{{item.quote_num}}</div>
						</div>
						<div class="hytiem" v-if="item.service_quote==1">
							<span>报价剩余时间：<CountDown :endTime="item.display_end_time*1000"></CountDown></span>
							<div style="width: 174px;background-color:#DDE2EE;color:#1E3A8A;">已报价{{item.quotes_count || '0'}}/{{item.quote_num}}</div>
						</div>
				   </div>
			   </div>
			   <div class="fenye" v-if="total>9">
				   <el-pagination
				     background
					 @current-change="handleCurrentChange"
					 :current-page.sync="currentPage1"
					 :page-size="9"
					 layout="total, prev, pager, next ,jumper"
					 :total="total">
				   </el-pagination>
			   </div>
		</div>
		<el-dialog
		  title="报价填写"
		  :visible.sync="dialogVisible"
		  :close-on-click-modal="false"
		  width="810px">
		  <div>
			  <div class="canshu" style="text-align:left;font-size: 12px;color: rgb(255, 0, 0);margin-bottom:10px;padding-left: 120px;">
			  	 需方付款后您需要在预计周期的一半时间内上传承认图，否则会导致订单退款，生产图同理
			  </div>
			 <el-form :model="valiFormData" :rules="rules" ref="valiFormData" label-width="120px" class="demo-ruleForm">
			   <el-form-item label="报价金额" prop="price">
			     <el-input v-model="valiFormData.price" placeholder="请根据要求合理报价">
					  <template slot="append">元</template>
				 </el-input>
				<!-- invite_status -->
			   </el-form-item>
			   <el-form-item label="预计完成时间" prop="period">
			      <el-input v-model="valiFormData.period" placeholder="请根据要求合理预估时间，便于需求方评估">
					   <template slot="append">小时</template>
				  </el-input>
			   </el-form-item>
			   </el-form-item>
			   <el-form-item label="附件上传" v-if="quote_file_config==1">
			 	   <el-upload
			 	     class="upload-demo"
			 	     :action="uploadActionUrl"
			 	     :on-preview="handlePreview"
			 	     :on-remove="handleRemove"
			 	     :on-success="handleUploadSuccess"
			 	     :before-remove="beforeRemove"
					 :multiple='false'
					 :limit="4"
			 	     :on-exceed="handleExceed"
			 	     :file-list="fileList">
			 		 <div>
			 			<el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
			 			<span style="margin-left:10px;font-size: 12px;color: #FF0000;">
			 				 单个文件最大支持10M，最多不超过四个文件，仅支持png，jpg，pdf文件类型
			 			</span>
			 		 </div>
			 	   </el-upload>
			   </el-form-item>
			 </el-form>
		  </div>
		  <div style="margin-top:30px;text-align: center;">
			<p style="color: #FF0000;margin-bottom:10px;font-size:12px;">提示：请如实填写报价信息，提交后不可修改</p>
			<span slot="footer" class="dialog-footer">
			  <el-button @click="dialogVisible = false">取 消</el-button>
			  <el-button type="primary" @click="submitForm('valiFormData')">确 定</el-button>
			</span>   
		  </div>
		</el-dialog>
  </div>
</template>

<script>
	import { mapState } from 'vuex'
	import {
		DemandIndex,
		banner,
		personal,
		QuoteAdd,
		BaseGetConfig
	} from "@/api/api.js"
	import config from '@/config/index'
	import CountDown from '@/common/CountDown'
	export default {
	  name: 'HelloWorld',
	  components:{
		 CountDown 
	  },
	  data() {
	    return {
		  currentPage1:"",
		  swiperDotIndex:0,
		  current:0,
		  mode: 'round',
		  keyword:"",
		  page:1,
		  list:[],
		  datails:"",
		  token:"",
		  bannerlist:[],
		  info:"",
		  site_title:"",
		  logo:"",
		  total:"",
		  
		  baseURL:config.baseURL,
		  dialogVisible:false,
		  valiFormData: {
				price: '',
				period: '',
				file:[]
		  },
		  quote_file_config:"",
		  rules: {
			price: [
			  { required: true, message: '报价金额不能为空', trigger: 'blur' },
			  { format: 'number', message: '报价金额只能是数字' }
			],
			period: [
			  { required: true, message: '完成周期不能为空', trigger: 'change' },
			]
		  },
		  fileList:[],
		  d_id:""
	    }
	  },
	  watch:{
		  dialogVisible:{
			  handler(newValue,oldValue){
				  if(newValue==false){
					    this.valiFormData.price=""
					    this.valiFormData.period=""
					    this.valiFormData.file=[]
						this.fileList=[]
					  }
				  },
				 deep:true
			}
	  },
	  computed: {
	  		isPersonalCenterActive() {
	  		  const p = this.$route && this.$route.path ? this.$route.path : ''
	  		  return /^\/demandHome\/(demandinvoiceList|demandUserInfo|demandPromotion)(\/|$)/.test(p)
	  		},
			// 完整上传地址 = baseURL + 接口路径（若后端路径不同请改下方 '/Upload/upload'）
			uploadActionUrl() {
				const base = this.baseURL || ''
				const path = (base.endsWith('/') ? '' : '/') + 'Upload/upload'
				return base + path
			},
			type(){
				return this.$route.query.type || ''
			},
			...mapState({
				user: (state) => state.userInfo || {}
			})
	  },
	  created() {
	  	this.token=localStorage.getItem('token')
	  	if(this.token){
	  		this.getpersonal()
			this.userinfo()
	  	}
		this.getlist()
		this.getbanner()
		this.getBaseGetConfig()
	  },
	  methods: {
		  userinfo(){
		      return this.$store.dispatch('fetchPersonal').then(() => {
		  	const u = this.user
		  	if (u && u.review_status == 1) {
		  		this.value = true
		  	} else {
		  		this.value = false
		  	}	
		  	})
		  },
		  downloadFile(url) {
		  	if (!url) return;
		  	const link = document.createElement("a");
		  	link.href = url;
		  	link.target = "_blank";
		  	link.download = "";
		  	document.body.appendChild(link);
		  	link.click();
		  	document.body.removeChild(link);
		  },
		handleExceed(files, fileList) {
		   this.$message.warning(`最多上传 4 个文件，当前已选 ${fileList.length} 个，本次选择了 ${files.length} 个，请勿超出限制`)
		},
		getUploadUrlFromResponse(response) {
		  if (!response) return ''
		  if (typeof response === 'string') return response
		  const level1 = response.data || {}
		  const level2 = level1.data || {}
		  const candidate =
			level2.url ||
			level2.file ||
			level1.url ||
			level1.file ||
			response.url ||
			response.file ||
			''
		  if (Array.isArray(candidate)) return candidate[0] || ''
		  if (typeof candidate === 'string') return candidate
		  if (Array.isArray(level1)) return level1[0] || ''
		  if (typeof level1 === 'string') return level1
		  return ''
		},
		handleUploadSuccess(response, file, fileList) {
		  this.fileList = fileList
		  const uploadedUrl = this.getUploadUrlFromResponse(response) || file.url || ''
		  if (uploadedUrl) {
			const exists = this.valiFormData.file.includes(uploadedUrl)
			if (!exists) this.valiFormData.file.push(uploadedUrl)
		  }
		},
		// beforeRemove(file, fileList) {
		//   return this.$confirm(`确定移除 ${file.name}？`)
		// },
		
		beforeRemove(file, fileList) {
		   this.fileList = fileList;
		   console.log(this.fileList)
		},
		
		handleRemove(file, fileList) {
		  this.fileList = fileList
		  const removedUrl = this.getUploadUrlFromResponse(file.response) || file.url || ''
		  if (!removedUrl) return
		  this.valiFormData.file = this.valiFormData.file.filter((url) => url !== removedUrl)
		},
		getBaseGetConfig(){
		  	BaseGetConfig({
		  		key:"quote_file_config"
		  	}).then(res=>{
		  		this.quote_file_config=res.data.data.quote_file_config
		  	})
		},
		handlePreview(file) {
		  console.log(file)
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				this.gettijiao()
			  } else {
				return false;
			  }
			});
		},
		gettijiao(){
			this.valiFormData.file=[]
			if(this.fileList.length>0){
				this.fileList.forEach(res=>{
					this.valiFormData.file.push(res.response.data)
				})
			}
			QuoteAdd({
				...this.valiFormData,
				d_id:this.d_id,
			}).then(res=>{
				console.log("333")
				if(res.data.status==200){
					this.$message.success('提交成功！');
					this.dialogVisible=false
					this.getlist()
				}else{
					// this.$message.error(res.data.msg);
				}
			})
		},
	    baojia(d_id){
			this.dialogVisible=true
			this.d_id=d_id
		},
		getdatails(e){
			const targetPath = '/serviceHome/serviceindex/servicedatails?d_id='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		handleCurrentChange(e){
			this.page=e
			this.getlist()
		},
		getpersonal(){
			personal({}).then(res=>{
				this.info=res.data.data
			})
		},
		getbanner(){
			banner({}).then(res=>{
				this.bannerlist=res.data.data
			})
		},
		chaxun(){
			this.page=1
			this.getlist()
		},
		getlist(){
			DemandIndex({
				page:this.page,
				status:"",
				keyword:this.keyword,
				limit:"9"
			}).then(res=>{
				console.log(res.data.data.data)
				this.total=res.data.total
				this.list=res.data.data.data
				this.datails=res.data.data
			})
		}
	  },
	}
</script>

<style scoped>
	.bannerlist{
		width:100%;
	}
	.sobox{
		width:100%;
		display:flex;
		justify-content:center;
		align-items:center;
		padding:24px 0px;
	}
	.soso{
		width:792px;
		height:52px;
		background: #FFFFFF;
		border-radius: 12px;
		border: 1px solid #1E3A8A;
		padding:10px 12px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items:center;
	}
	.soso button{
		width: 60px;
		height: 32px;
		background: #1E3A8A;
		border-radius: 8px 8px 8px 8px;
		font-weight: 500;
		font-size: 14px;
		color: rgba(255,255,255,0.9);
	    border: none;
	}
	.soinput input{
		width:670px;
		border:none;
		outline:none;
		font-weight: 400;
		font-size: 14px;
	}
	.xqlist{
		width:1200px;
		margin: 0 auto;
		display:flex;
/* 		justify-content:space-between; */
		flex-wrap:wrap;
	}
	.xqlist>div:nth-child(3n){
		margin-right:0px;
	}
	.liebiao1{
		width:384px;
		height:233px;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px;
		margin-bottom:24px;
		margin-right:24px;
		padding:12px;
		box-sizing: border-box;
		cursor:pointer;
		transition: all 0.3s;
		position: relative;
	}
	.liebiao1:hover{
		transform: scale(1.03);
	}
	.title{
		width:100%;
		display:flex;
		justify-content:space-between;
	}
	.titleh4{
		width:260px;
		overflow: hidden; 
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.title span{
		color:#1E3A8A;
	}
	.titleTiem{
		width:100%;
		display:flex;
		align-items: center;
	}
	.titleTiem img{
		width:12px;
		height:12px;
		margin-right:5px;
	}
	.titleTiem span{
		font-weight: 400;
		font-size: 12px;
		color: #999999;
	}
	.hylist{
		width:100%;
		max-height:60px;
		overflow: hidden;
	}
	
	.hylist::-webkit-scrollbar {
	      display: none;           /* Chrome/Safari 隐藏滚动条 */
	}
	.hylist div>div{
        padding:3px 5px;
		box-sizing: border-box;
		background: rgba(66,151,255,0.15);
		border-radius: 4px;
		float: left;
		font-weight: 500;
		font-size: 12px;
		color: #4297FF;
		margin-right:6px;
		margin-top:6px;
	}
	.hybox{
		width:100%;
		height:60px;
		margin-top:5px;
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		display: -webkit-box;
		line-clamp: 3;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.hytiem{
		width:360px;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-top:12px;
		position: absolute;
		bottom: 15px;
		/* border-radius: 4px 4px 4px 4px;
		padding:5px 8px;
		box-sizing: border-box; */
	}
	::v-deep .el-dialog__footer{
		text-align: center !important;
	}
	.hytiem span{
		font-weight: 500;
		font-size: 12px;
		color: #FF5900;
	}
	.hytiem div{
		width: 174px;
		height: 30px;
		background: #1E3A8A;
		border-radius: 8px;
		display:flex;
		justify-content:center;
		align-items: center;
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
	}
	.fenye{
		width:100%;
		display:flex;
		justify-content:center;
		align-items: center;
		padding-bottom:60px;
	}
	
</style>